export default {
  USER_GET_COMPLIANCE: '/User/GetCompliance',
};
